import Header from "../../components/header";

const About = () => {
  return (
    <>
      <Header hideSearchBar={true} />
      <div className="min-h-screen bg-gray-50 py-12 px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
              <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h1 className="text-3xl font-bold text-gray-900">About Us</h1>
          </div>

          <div className="space-y-6">
            <div className="p-5 bg-[#e8f0f7]/30 rounded-xl border-l-4 border-[#0f6abf]">
              <p className="text-gray-800 leading-relaxed">
                <strong>Welcome to Axionnest</strong> — a platform built to empower
                researchers, scholars, and academic enthusiasts. We make publishing
                and discovering research simple, engaging, and accessible to
                everyone.
              </p>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1.5 h-5 bg-[#0f6abf] rounded-full"></div>
                <h2 className="text-xl font-semibold text-gray-900">Our Mission</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">
                At Axionnest, our goal is to foster a global, collaborative
                environment where ideas can be shared freely, and innovation can
                thrive. Whether you are a student, a researcher, or an institution,
                we provide tools to share your work, gain visibility, and connect
                with like-minded professionals.
              </p>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1.5 h-5 bg-[#0f6abf] rounded-full"></div>
                <h2 className="text-xl font-semibold text-gray-900">What We Offer</h2>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                  <span className="text-xl">📚</span>
                  <div>
                    <strong className="text-gray-900">Easy Publishing:</strong>
                    <span className="text-gray-700"> Upload theses, journals, chapters, images, or ideas in just a few clicks.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                  <span className="text-xl">🔍</span>
                  <div>
                    <strong className="text-gray-900">Smart Search:</strong>
                    <span className="text-gray-700"> Find content by title, keyword, author, or type — fast and efficiently.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                  <span className="text-xl">👥</span>
                  <div>
                    <strong className="text-gray-900">Engaged Community:</strong>
                    <span className="text-gray-700"> Follow authors, react to content, and stay connected with trending discussions.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                  <span className="text-xl">📈</span>
                  <div>
                    <strong className="text-gray-900">Live Insights:</strong>
                    <span className="text-gray-700"> Track reads and user engagement to see the impact of your research.</span>
                  </div>
                </li>
              </ul>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1.5 h-5 bg-[#0f6abf] rounded-full"></div>
                <h2 className="text-xl font-semibold text-gray-900">Why Axionnest?</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">
                We bridge the gap between traditional publishing and modern
                collaboration. Axionnest is the new home for researchers who value
                visibility, community, and simplicity.
              </p>
            </div>

            <div className="pt-4">
              <div className="p-5 bg-[#e8f0f7] rounded-xl text-center">
                <p className="text-gray-800 font-medium">
                  Join us in building a smarter, more connected future for research.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;